export const checkAllUserLists = (userList, checked) => {
  return userList.map((u) => ({ ...u, checked }));
};

export const updateSelectedUserList = (
  selectedUserList,
  teamsOptions,
  teamName,
) => {
  const selectedUsers = selectedUserList.map((u) => {
    const user = { ...u };
    const userHasTeam = user.team.some((t) => t.name === teamName);

    if (userHasTeam) return user;
    const team = teamsOptions.find((option) => option.label === teamName);

    user.team = [
      ...user.team,
      {
        name: team.label,
        id: team.key,
      },
    ];

    return user;
  });

  return selectedUsers;
};

export const updateUserListTeams = (users, list) => {
  const userList = [...list];

  users.forEach((u) => {
    const user = { ...u };
    // find user's index in userList
    const userListIndex = userList.findIndex((ele) => ele.email === user.email);

    user.teamDisplay = user.team.map((t) => t.name).join(', ');

    // insert updated user into baseUserList and userList
    userList[userListIndex] = {
      ...userList[userListIndex],
      ...user,
    };
  });

  return userList;
};
